import Upload from "@mui/icons-material/Upload";

import { makeSvgIcon } from "./svg-icon";

export const FileUploadIcon = makeSvgIcon(Upload);

export default FileUploadIcon;
